<template>	   
	<v-container >
	  <v-layout row wrap justify-center>
	    <v-flex md6 offset-md5 text-md-center>
			<v-img :src="logo" max-height="225" max-width="85"></v-img>
		</v-flex>
    	<v-flex xs7 text-md-center>
	    	<v-card elevation="4">
	    		<v-card-title primary-title>
	    			<v-layout row wrap justify-center>
	    			  
	    				<v-flex md12 text-md-center>
	    					<h4 class="display-1">GIS Mundo Sano</h4>
							<br><br>
	    				</v-flex>
	    			</v-layout>
	    		</v-card-title>
	    	  <v-card-text>
	    	    <v-layout row wrap justify-center>
	    	      <v-flex xs10 text-md-center>
	    	      	<label>Correo electronico</label>
	    	        <v-text-field
	    	          name="email"
	    	          label="example@example.com"
	    	          id="email"
	    	          v-model="form.email"
	    	          solo
	    	        ></v-text-field>
	    	        <label>Contraseña</label>
	    	        <v-text-field
	    	          name="password"
	    	          label="*********"
	    	          id="password"
	    	          solo
	    	          v-model="form.password"
	    	          :type="type ? 'password' : 'text'"
	    	          :append-icon="type ? 'fas fa-eye-slash' : 'fas fa-eye'"
	    	          @click:append="type = !type"
	    	          @keyup.enter="login"
	    	        ></v-text-field>
	    	        <v-btn @click="login()" :loading="loading" color="success">Ingresar</v-btn>
	    	      </v-flex>
	    	    </v-layout>
	    	  </v-card-text>
	    	</v-card>
    	</v-flex>
	  </v-layout>
	  <v-snackbar :color="alert.color"
	    v-model="alert.active"
	  >
	    {{ alert.message }}
	    <v-btn text color="black" @click.native="alert.active = false">Close</v-btn>
	  </v-snackbar>
	</v-container>
</template>
<script>
	export default{
		created() {

		},
		mounted(){

		},
		props: [

		],
		data(){
			return {
    		logo: '/img/logo1.png',
				baseRoute: 'http://gis.localdev.com.ar/api/modis',
				type: true,
				user: '',
				form: {
					email: '',
					password: '',
				},
				response: '',
				alert: {
					active: false,
					message: "Nombre de usuario o Contraseña incorrecta",
					color: "error"
				},
				loading: false,
			}
		},
		methods: {
			login(){
				this.loading = true;
				this.response = this.$store.dispatch('api/login', this.form).then((res) => {
					this.loading = false;
					if(this.$store.state.api.user.role_id == 1){
      			this.$router.push('/dashboard');
					}else{
      			this.$router.push('/gis');
					}
					
				}).catch((error) => {
					this.loading = false;
					this.alert= {
						active: true,
						message: "Nombre de usuario o Contraseña incorrecta",
						color: "error"
					}
				})
			}	
		},
		watch: {

		},
		computed: {

		},
	}
</script>